import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createHashHistory } from "history";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";

// include action file for add merchant
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import { getMerchantType } from "../../../redux/actions/merchantActions";
import { getAllCategorys } from "../../../redux/actions/categories";
import { saleReport } from "../../../redux/actions/reportAction";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import DatePicker from "react-date-picker";
import DateRangePicker from "@wojtekmaj/react-daterange-picker";
import moment from "moment";
import loader from "../../../style/loader/loader.scss";
import "../../../style/react-datetimepicker.scss";
import { CSVLink } from "react-csv";
import {aclUtil} from "../../util"
import './SalesReport.css'

const history = createHashHistory();
let rand = require("random-key");
const HorizontalLine = ({}) => <hr />;

const propTypes = {
  saleReport: PropTypes.func.isRequired
};
let cityItems = [];
let isLoading = "false",
  csvData = [];
class SalesReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuKey: 'SALES_REPORT',
      path: ["Home", "Sale Report"],
      links: ["home", "report/sales"],
      date: new Date(),
      range: false,
      disabled: false,
      catID: "",
      merchantTypeID: "",
      sales: [],
      isLoading: "false",
      csvData: ""
    };

    this.validate = this.validate.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear = this.Clear.bind(this);
    this.changeDatePicker = this.changeDatePicker.bind(this);
  }

  onChangeStartDate = date => { this.setState({ startDate: date })};
  onChangeStartDateRange = date => this.setState({ startDateRange: date });
  changeDatePicker = status => {
    if (this.state.range == false) {
      this.setState({ range: true });
    } else {
      this.setState({ range: false });
    }
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  // Handle input onchange
  handleChange(e) {
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    return isError;
  };

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();
    let formData;

    if (!err) {
      this.setState({ sales: "" });
      isLoading = "true";
      if (this.state.range == true) {
        let dateRange = this.state.startDateRange;
        formData = {
          startDate: moment(dateRange[0]).format('YYYY-MM-DD'),
          endDate: moment(dateRange[1]).format('YYYY-MM-DD'),
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          site_id: localStorage.getItem("siteID")
        };
      } else {
        formData = {
          startDate: moment(this.state.startDate).format('YYYY-MM-DD'),
          catID: this.state.catID,
          merchantTypeID: this.state.merchantTypeID,
          site_id: localStorage.getItem("siteID")
        };
      }
      this.props.saleReport(formData);
    }
  }

  Clear = () => {};

  handlePageChange = page => {};

  componentWillMount() {
    this.props.clearAlert();
    this.handleDismiss();
    this.props.getMerchantType({site_id: localStorage.getItem("siteID")});
    this.props.getAllCategorys({site_id: localStorage.getItem("siteID")});
  }
  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.props.history.push("/restrictedAccess");
    }
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
        isLoading = "false";
        this.setState({ sales: "" });
      }
    }

    if (this.props.merchantType !== nextProps.merchantType) {
      if (nextProps.merchantType) {
        this.setState({ merchantType: nextProps.merchantType });
      }
    }

    if (this.props.catData !== nextProps.catData) {
      if (nextProps.catData) {
        this.setState({ catData: nextProps.catData.data.data });
      }
    }

    if (this.props.sales !== nextProps.sales) {
      if (nextProps.sales) {
        isLoading = "false";
        this.setState({ sales: nextProps.sales.data });
        this.handleExport(nextProps.sales.data);
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  handleExport = data => {
    csvData = [
      [
        'All Markets',
        'Offer ID',
        'Offer Name',
        'Start Date',
        'End Date',
        'Voucher Expiration Date',
        'Offer Value',
        'Purchase Price',
        'Quantity Sold',
        'Vouchers Redeemed',
        'Vouchers Not Redeemed',
        'Number Expired ',
        'Redeemed After Expired  ',
        'Merchant Commission Split',
        'Gross Sales',
        'Promo Code Amount',
        'Merchant Payout Amount',
        'Shipping Amount',
        'Shipping Amount Admin',
        'Shipping Amount Merchant',
        'Tax Fees',
      ]
    ];

    if (!isEmpty(data)) {
      data.map((sale, index) => {
        Object.keys(sale).map((key, indexkey) => 
          (key == 'city_title') ?
            csvData.push([
              sale.city_title,
            ])
          : (key == 'saleRecord') &&
            sale.saleRecord.map((records, recKey) =>
              csvData.push([
                records.legalName,
                records.dealID,
                records.dealText,
                records.startDateTime,
                records.expiryDateTime,
                records.voucher_expiry_date,
                records.retailPrice,
                records.offerPrice,
                records.quantity_sold,
                records.redeemed_vouchers,
                records.vouchers_not_redeemed,
                records.vouchersExpired,
                records.redeemedAfterExpiration,
                records.merchantCommissionSplit,
                records.grossSales,
                records.promo_code_amount,
                records.merchantPayoutAmount,
                records.shipping_amount,
                records.shippingAmountAdmin,
                records.shippingAmountMerchant,
                records.taxFees,
              ])
            )
        )
      });
    }

    this.setState({ csvData: csvData });
  };

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="row">
          <div className="col-xs-12">
            <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Sales Report</header>
            <div className="panel-body">
              <Row className="reportfilter">
                <Col md={1} xs={12}>
                  <FormGroup controlId="currency">
                    <ControlLabel>Currency</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.currencyError }}
                      name="currency"
                      value={this.state.currency}
                    >
                      <option value="$">$</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <ControlLabel>Date</ControlLabel>
                  <FormGroup controlId="formOfferTitle">
                    {this.state.range == false ? (
                      <DatePicker
                        onChange={this.onChangeStartDate}
                        value={this.state.startDate}
                      />
                    ) : (
                      <DateRangePicker
                        onChange={this.onChangeStartDateRange}
                        value={this.state.startDateRange}
                      />
                    )}
                  </FormGroup>
                </Col>
                <Col md={2} xs={12}>
                  <FormGroup controlId="proposalType">
                    <ControlLabel>Proposal Type</ControlLabel>
                    <FormControl
                      componentClass="select"
                      onChange={this.handleChange}
                      style={{ borderColor: this.state.merchantTypeIDError }}
                      name="merchantTypeID"
                      value={this.state.merchantTypeID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.merchantType) &&
                        this.state.merchantType.map((type, index) => (
                          <option
                            key={type.merchantTypeID}
                            value={type.merchantTypeID}
                          >
                            {type.merchantTypeName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={3} xs={12}>
                  <FormGroup controlId="catID">
                    <ControlLabel>Category</ControlLabel>
                    <FormControl
                      componentClass="select"
                      style={{ borderColor: this.state.catIDError }}
                      onChange={this.handleChange}
                      name="catID"
                      value={this.state.catID}
                    >
                      <option value="">All</option>
                      {!isEmpty(this.state.catData) &&
                        this.state.catData.map((type, index) => (
                          <option key={type.catID} value={type.catID}>
                            {type.catName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
              
                <Col md={3} xs={12}>
                  <Button
                    bsStyle="info"
                    type="submit"
                    id="saveButton"
                    disabled={this.state.disabled}
                  >
                    Submit
                  </Button>
                  {this.state.range == false ? (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Range
                    </a>
                  ) : (
                    <a
                      className="btn btn-success"
                      type="submit"
                      onClick={this.changeDatePicker}
                      id="saveButton"
                    >
                      Use Date
                    </a>
                  )}
                  {this.state.csvData ? (
                    <CSVLink
                      data={this.state.csvData}
                      filename={"sales-report.csv"}
                      className="btn btn-default"
                    >
                      Export CSV
                    </CSVLink>
                  ) : null}
                </Col>
              </Row>
            </div>
          </div>
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body table-responsive">
            <table className="table table-hover table-bordered">
              <thead>
                <tr>
                  <th>All Markets</th>
                  <th>Offer ID</th>
                  <th>Offer Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Voucher Expiration Date</th>
                  <th>Offer Value</th>
                  <th>Purchase Price</th>
                  <th>Quantity Sold</th>
                  <th>Vouchers Redeemed</th>
                  <th>Vouchers Not Redeemed</th>
                  <th>Number Expired </th>
                  <th>Redeemed After Expired  </th>
                  <th>Merchant Commission Split</th>
                  <th>Gross Sales</th>
                  <th>Promo Code Amount</th>
                  <th>Merchant Payout Amount</th>
                  <th>Shipping Amount</th>
                  <th>Shipping Amount Admin</th>
                  <th>Shipping Amount Merchant</th>
                  <th>Tax Fees</th>
                </tr>
              </thead>
              <tbody>
                {!isEmpty(this.state.sales) ? (
                  this.state.sales.map((sale, index) => 
                    Object.keys(sale).map((key, indexkey) => 
                    (key == 'city_title') ?
                    <tr key={Math.random()+index}>
                      <td colSpan="25">#{++index} {sale.city_title}</td>
                    </tr>
                    : (key == 'saleRecord') &&
                      sale.saleRecord.map((records, recKey) =>
                      <tr key={Math.random()+recKey}>
                        <td>{records.legalName}</td>
                        <td>{records.dealID}</td>
                        <td>{records.dealText}</td>
                        <td>{records.startDateTime}</td>
                        <td>{records.expiryDateTime}</td>
                        <td>{records.voucher_expiry_date}</td>
                        <td>{records.retailPrice}</td>
                        <td>{records.offerPrice}</td>
                        <td>{records.quantity_sold}</td>
                        <td>{records.redeemed_vouchers}</td>
                        <td>{records.vouchers_not_redeemed}</td>
                        <td>{records.vouchersExpired}</td>
                        <td>{records.redeemedAfterExpiration}</td>
                        <td>{records.merchantCommissionSplit}</td>
                        <td>{records.grossSales}</td>
                        <td>{records.promo_code_amount}</td>
                        <td>{records.merchantPayoutAmount}</td>
                        <td>{records.shipping_amount}</td>
                        <td>{records.shippingAmountAdmin}</td>
                        <td>{records.shippingAmountMerchant}</td>
                        <td>{records.taxFees}</td>
                      </tr>
                      )
                    )
                  )
                ) : (
                  <tr key={Math.random()}>
                    <td colSpan="25">Data Not Available</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    error: state.reportReducer.error,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    merchantType: state.merchantReducer.merchantType,
    catData: state.categoryReducer.catData,
    sales: state.reportReducer.sales
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, {
    renderAlert,
    clearAlert,
    getMerchantType,
    getAllCategorys,
    saleReport
  })
)(SalesReport);



// WEBPACK FOOTER //
// ./src/app/views/admin/reports/SalesReport.js